"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboLocationNamesSummary = void 0;
function getComboLocationNamesSummary(trips) {
    return trips
        .flatMap((trip, i) => {
        if (trip.destinationLocationName === trips[i + 1]?.originLocationName) {
            return [trip.originLocationName];
        }
        return [trip.originLocationName, trip.destinationLocationName];
    })
        .join(" → ");
}
exports.getComboLocationNamesSummary = getComboLocationNamesSummary;
//# sourceMappingURL=getComboLocationNamesSummary.js.map